import { validateRequiredFieldWithArrayValue } from '@framework/ui/Organisms/FinalForm/validators/validateRequiredFieldWithArrayValue';
import { validateRecaptchaVerified } from '@framework/ui/Organisms/FinalForm/validators/validateRecaptchaVerified';
import { groupValidators } from '@framework/ui/Organisms/FinalForm/validators/helpers';

const comments = { fieldName: 'comments', fieldCaption: 'Comments', isPlural: true };

export default (values) => groupValidators(
  validateRequiredFieldWithArrayValue({ ...comments, value: values.comments }),
  validateRecaptchaVerified({ fieldName: 'recaptcha', value: values.recaptcha }),
);
